export const IDLE = 'idle';
export const PENDING = 'pending';
export const LOADING = 'loading';
export const SUCCEEDED = 'succeeded';
export const FAILED = 'failed';
